var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4526_5453)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 33.75C22.1772 33.75 26.1832 32.0906 29.1369 29.1369C32.0906 26.1832 33.75 22.1772 33.75 18C33.75 13.8228 32.0906 9.81677 29.1369 6.86307C26.1832 3.90937 22.1772 2.25 18 2.25C13.8228 2.25 9.81677 3.90937 6.86307 6.86307C3.90937 9.81677 2.25 13.8228 2.25 18C2.25 22.1772 3.90937 26.1832 6.86307 29.1369C9.81677 32.0906 13.8228 33.75 18 33.75ZM18 36C22.7739 36 27.3523 34.1036 30.7279 30.7279C34.1036 27.3523 36 22.7739 36 18C36 13.2261 34.1036 8.64773 30.7279 5.27208C27.3523 1.89642 22.7739 0 18 0C13.2261 0 8.64773 1.89642 5.27208 5.27208C1.89642 8.64773 0 13.2261 0 18C0 22.7739 1.89642 27.3523 5.27208 30.7279C8.64773 34.1036 13.2261 36 18 36Z",
    fill: "#17A2B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0924 14.8223L14.9399 15.468L14.7554 16.323L15.7679 16.5098C16.4294 16.6673 16.5599 16.9058 16.4159 17.565L14.7554 25.368C14.3189 27.3863 14.9916 28.3358 16.5734 28.3358C17.7996 28.3358 19.2239 27.7688 19.8696 26.9903L20.0676 26.0543C19.6176 26.4503 18.9606 26.6078 18.5241 26.6078C17.9054 26.6078 17.6804 26.1735 17.8401 25.4085L20.0924 14.8223Z",
    fill: "#17A2B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12.375C19.2426 12.375 20.25 11.3676 20.25 10.125C20.25 8.88236 19.2426 7.875 18 7.875C16.7574 7.875 15.75 8.88236 15.75 10.125C15.75 11.3676 16.7574 12.375 18 12.375Z",
    fill: "#17A2B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4526_5453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/infoCircle.b7aa35fc961eae5a5e8d9058af6ec5ac.svg";
export { ForwardRef as ReactComponent };